import React from "react";
import Image from "../../../components/AppImage";

const CareerHeroSection = () => {
  return (
    <section className="relative w-full min-h-[90vh] bg-gradient-to-br from-[#f6f5f3] via-[#eef3f8] to-[#e8f2f1] overflow-hidden">
      <div className="max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-2 min-h-[90vh]">

        {/* LEFT CONTENT */}
        <div className="flex flex-col justify-center px-8 lg:px-20 py-16 space-y-8 z-10 mt-10 lg:mt-15">
          <h1 className="text-4xl lg:text-6xl font-bold text-slate-900 leading-tight">
            Build Your Career. <br />
            <span className="text-accent">Grow With Fstone.</span>
          </h1>

          <p className="text-lg text-slate-700 max-w-xl">
            At Fstone Technologies, we believe great careers are built with
            purpose, innovation, and collaboration. Join a team where your
            ideas matter and your growth is supported.
          </p>

          {/* STATS */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-xl">
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <h3 className="text-3xl font-bold text-slate-900">100+</h3>
              <p className="text-sm text-slate-600">
                Professionals onboard
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <h3 className="text-3xl font-bold text-slate-900">10+</h3>
              <p className="text-sm text-slate-600">
                Career domains & roles
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <h3 className="text-3xl font-bold text-slate-900">Fast</h3>
              <p className="text-sm text-slate-600">
                Learning & growth culture
              </p>
            </div>
          </div>

          {/* CTA */}
         <div className="mt-10 flex justify-center">
            <a
              href="https://www.hirees.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative overflow-hidden inline-flex items-center justify-center 
                         bg-black text-white px-14 py-5 rounded-full font-semibold 
                         transition-all duration-300 hover:bg-accent hover:shadow-lg 
                         min-w-[320px]"
            >
              <span
                className="absolute left-4 w-9 h-9 rounded-full bg-blue-400 text-black 
                           flex items-center justify-center transition-all duration-300 
                           group-hover:left-[calc(100%-3rem)]"
              >
                →
              </span>

              <span className="relative z-10">
                Explore Open Positions
              </span>
            </a>
          </div>
        </div>

        {/* RIGHT IMAGE (DIAGONAL) */}
        <div className="relative hidden lg:block">
          <div
            className="absolute inset-0"
            style={{
              clipPath: "polygon(12% 0, 100% 0, 100% 100%, 0 100%)",
            }}
          >
            <Image
              src="/careerHero.jpg"
              alt="Careers at Fstone Technologies"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

      </div>
    </section>
  );
};

export default CareerHeroSection;
